import React, { Fragment, useState, useEffect } from 'react'
import { Row, Col, CardHeader, CardBody, CardFooter, Form, FormGroup, Label, Input } from 'reactstrap'
import { Breadcrumbs, Btn, H4 } from '../../AbstractElements'
import { getIdData } from '../../lib/studentinfo'
import { addData } from '../../lib/taskm'
import { getIdData as getClassData } from '../../lib/class'
import { getDataWithClass, getStudentClass } from '../../lib/classdetailview'
import { TaskTopic911Select, TaskTopic12Select } from '../Common/FormSelects'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { TextEditor } from '../Common/TextEditor'

const TaskManage = () => {
	const [desc, setDesc] = useState()
	const [studentClass, setStudentClass] = useState()
	const [toInfo, setToInfo] = useState('')
	const [classDetail, setClassDetail] = useState([])
	const [taskTopic, setTaskTopic] = useState(null)
	const { user } = useAuth()
	const [instructorId, setInstructorId] = useState()
	const navigate = useNavigate()
	let { id, type } = useParams()
	const [date, setDate] = useState()

	const getCurrentDateInput = () => {
		const dateObj = new Date()

		// get the month in this format of 04, the same for months
		const month = ('0' + (dateObj.getMonth() + 1)).slice(-2)
		const day = ('0' + dateObj.getDate()).slice(-2)
		const year = dateObj.getFullYear()

		const shortDate = `${year}-${month}-${day}`

		setDate(shortDate)
	}

	async function GetStudentData() {
		try {
			const info = await getIdData(id)
			const classinfo = await getStudentClass(id)

			if (info && info.length > 0 && classinfo && classinfo.length > 0) {
				setInstructorId(classinfo[0].instructorId)
				setToInfo(info[0].name + ' ' + info[0].surname)
				setStudentClass(info[0].class)
			} else {
				console.error('No student data found for ID:', id)
			}
		} catch (error) {
			console.error('Error fetching student data:', error)
		}
	}

	async function GetClassData() {
		try {
			const info = await getClassData(id)
			if (info && info.length > 0) {
				setToInfo(info[0].class_name)
				setStudentClass(info[0].grade)

				const classinfo = await getDataWithClass(id, user.id)
				setClassDetail(classinfo)
			} else {
				console.error('No class data found for ID:', id)
			}
		} catch (error) {
			console.error('Error fetching class data:', error)
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault()

		if (type === 'Student') {
			await addData({
				from: instructorId,
				to: id,
				setDate: date,
				subject: taskTopic,
				desc: desc
			})
		}

		if (type === 'Class') {
			classDetail.map(async function (data) {
				await addData({
					from: data.instructorId,
					to: data.studentId,
					setDate: date,
					subject: taskTopic,
					desc: desc
				})
			})
		}
		navigate(-1)
	}

	useEffect(() => {
		getCurrentDateInput()
		if (type === 'Student' && user) {
			GetStudentData()
		}
		if (type === 'Class' && user) {
			GetClassData()
		}
	}, [])

	return (
		<Fragment>
			<Breadcrumbs mainTitle="Task Management" parent="Class Management" title="Add Task" />
			<Form className="card" onSubmit={handleSubmit}>
				<CardHeader>
					<H4 attrH4={{ className: 'card-title mb-0' }}>{type === 'Student' ? 'Add Item to Student' : 'Add Item to Class'}</H4>
					<div className="card-options">
						<a className="card-options-collapse" href="#javascript">
							<i className="fe fe-chevron-up"></i>
						</a>
						<a className="card-options-remove" href="#javascript">
							<i className="fe fe-x"></i>
						</a>
					</div>
				</CardHeader>
				<CardBody>
					<Row>
						<Col md="12">
							<FormGroup>
								<Label className="form-label">
									<h5>{toInfo}</h5>
								</Label>
							</FormGroup>
						</Col>
						<Col md="6">
							<FormGroup>
								<Label className="form-label">Topic</Label>
								{studentClass > 11 ? (
									<TaskTopic12Select value={taskTopic} setValue={setTaskTopic} />
								) : (
									<TaskTopic911Select value={taskTopic} setValue={setTaskTopic} />
								)}
							</FormGroup>
						</Col>
						<Col md="6">
							<FormGroup>
								<Label className="form-label">Date</Label>
								<Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="form-control" />
							</FormGroup>
						</Col>
						<Col md="12">
							<FormGroup>
								<Label className="form-label">Description</Label>
								<div id="editor">
									<TextEditor value={desc} setValue={setDesc} />
								</div>
							</FormGroup>
						</Col>
					</Row>
				</CardBody>
				<CardFooter className="text-end">
					<Btn attrBtn={{ color: 'primary', type: 'submit', className: 'me-2' }}>{type === 'Add' ? 'Add Item' : 'Update Item'}</Btn>
					<Btn attrBtn={{ color: 'secondary', className: 'me-2', onClick: () => navigate(-1) }}>Cancel</Btn>
				</CardFooter>
			</Form>
		</Fragment>
	)
}

export { TaskManage }
